import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { GlobalFormats } from '../../classes/main/globalFormats';

import {
    responseGet, globalSettings, styles, dateTimeFormatGlobalSet, separatorsNumbersSet, numberSet, buttonProcessGet, sendMessageCloseCurrentWindowAsync,
    languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';
import { collectionCashModelGet } from '../../models/collections/collectionCash';
import { userModelGet } from '../../models/users/user';
import HtmlParser from 'react-html-parser';

const currentMethod = 'ReconciliePaymentEditDetails';
const neutralValue = 0.00;

const { app, collections: dbColle, html, icons, images, labels, messages, react } = globalSettings;
const { properties: dbProps, } = dbColle;
const { html: reactHtml, tempusDominus, } = react;
const { backend, } = app;

export default function ReconciliePaymentEditDetails({
    $ = {},
    auth = {},
    buildingBalance = neutralValue,
    setBuildingBalance = () => { },
    headerSectionValues = {
        levelOne: {
            colOne: {},
            colTwo: {},
            colThree: {
                label: labels?.balance?.['en'],
                value: separatorsNumbersSet({
                    number: neutralValue,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                icon: icons?.moneyBillWave,
                className: 'form-control bg-transparent text-black text-right',
            },
        }
    },
    setHeaderSectionValues = () => { },
    apartment = apartmentModelGet({}),
    payment = apartmentReceiptPaymentModelGet({}),
    setPayment = () => { },
    paymentBeforeEdit = apartmentReceiptPaymentModelGet({}),
    dtPaymentsId = '',
    paymentMethodDescription = '',
    collectionCashes = [collectionCashModelGet({})],
    bankDescriptionOrigin = '',
    bankDescriptionDestiny = '',
    bankAccountNumber = '',
    userConciliation = userModelGet({}),
    paymentsGetAsync = async ({
        e = {},
        processType_ = 0,
        subMethod = '',
    }) => { },
    rowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    processTypeWindow = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [formTitle, setFormTitle] = useState('');
    const [isReadOnly] = useState(processTypeWindow === 0);
    const [collectionCashError, setCollectionCashError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnApartmentReceiptPaymentModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnApartmentReceiptPaymentModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnApartmentReceiptPaymentModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            concilationStatus: {
                id: 'chkApartmentReceiptPaymentModalConcilationStatus',
                className: 'icheck-primary d-inline',
            },
            inactiveReadOnly: {
                id: 'chkApartmentReceiptPaymentModalReadOnly',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCollectionCashesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCollectionCashesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCollectionCashesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCollectionCashesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCollectionCashesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCollectionCashesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCollectionCashesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCollectionCashesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoApartmentReceiptPaymentModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoApartmentReceiptPaymentModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoApartmentReceiptPaymentModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            conciliationRemark: {
                id: 'inputApartmentReceiptPaymentModalConciliationRemark',
                className: 'form-control',
            },
        },
        selects: {
            collectionCashes: {
                id: 'selApartmentReceiptPaymentModalCollectinCashes',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spApartmentReceiptPaymentModalSave',
                className: '',
            },
            back: {
                id: 'spApartmentReceiptPaymentModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errorDefaultSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setCollectionCashError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const paymentConcilationStatusCheck = ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentConcilationStatusCheck';
        let response = responseGet();
        try {
            switch (e?.target?.checked) {
                case true:
                    setPayment({
                        ...payment,
                        [dbProps?.concilationDate]: new Date(),
                        [dbProps?.concilationStatus]: 'S',
                        [dbProps?.conciliationUserId]: auth?.user?.uid,
                    });
                    break;
                default:
                    setPayment({
                        ...payment,
                        [dbProps?.concilationDate]: new Date(),
                        [dbProps?.conciliationRemark]: '',
                        [dbProps?.concilationStatus]: '',
                        [dbProps?.conciliationUserId]: '',
                        [dbProps?.collectionCashId]: '',
                    });
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const dtPaymentUpdateDataAsync = async ({
        dtPayments = {},
        paymentConcilationStatus = '',
        subMethod,
    }) => {
        const currentMethod = 'dtPaymentUpdateDataAsync';
        let response = responseGet();
        try {
            //#region variables
            dataObj = {
                dateOrder: dateTimeFormatGlobalSet({
                    date: payment?.date,
                    type: tempusDominus?.format?.date?.ymdTwo,
                    format: 24,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                status: `${paymentConcilationStatus}${html?.space?.formatOne}${paymentMethodDescription}`,
                reference: payment?.reference,
                date: dateTimeFormatGlobalSet({
                    date: payment?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                amount: separatorsNumbersSet({
                    number: numberSet({
                        number: payment?.amount,
                        type: 'd',
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            dtPayments.row(rowIndex)?.data?.([
                dataObj?.dateOrder,
                dataObj?.status,
                dataObj?.reference,
                dataObj?.date,
                dataObj?.amount,
                buttonProcessGet({
                    id: payment?.id,
                    description: paymentMethodDescription,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.reconcile?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ]);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: payment?.bankId, subMethod: currentMethod, })?.result &&
                isUndNullEmp({ data: payment?.collectionCashId, subMethod: currentMethod, })?.result &&
                payment?.concilationStatus === 'S') {
                //#region old code
                // response.msgType = 1;
                // response.result = false;
                // response.isWarning = true;
                // response.msgText = `${messages?.youMustSelectRegisterCash?.[languageObj?.id]}`;
                // await sendMessageCloseCurrentWindowAsync({
                //     msgType: response?.msgType,
                //     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //     closeWindow: false,
                //     urlGoTo: response?.urlGoTo,
                //     auth: auth,
                //     isLogout: false,
                //     languageId: languageObj?.id,
                //     subMethod: currentMethod,
                // });
                //#endregion old code
                response.msgType = 1;
                response.result = false;
                response.isWarning = true;
                setCollectionCashError(`${messages?.thisFieldRequired?.[languageObj?.id]}.`);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptPaymentUpdateAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymentUpdateAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let concilationStatusLocal = '';
            let buildingBalanceLocal = neutralValue
            const dtPaymentsLocal = $(`#${dtPaymentsId}`)?.DataTable();
            let apartmentreceiptPaymentLocal = apartmentReceiptPaymentModelGet({});
            //#endregion variables

            //#region errorDefaultSetAsync
            response = await errorDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errorDefaultSetAsync

            //#region form data validate
            response = await formDataValidateAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update data (payment)
            concilationStatusLocal = isUndNullEmp({ data: payment?.conciliationRemark, subMethod: currentMethod, })?.result
                && (payment?.concilationStatus === 'W' || isUndNullEmp({ data: payment?.concilationStatus, subMethod: currentMethod, })?.result) ?
                '' :
                (!isUndNullEmp({ data: payment?.conciliationRemark, subMethod: currentMethod, })?.result && !isUndNullEmp({ data: payment?.concilationStatus, subMethod: currentMethod, })?.result && payment?.concilationStatus === 'W') ?
                    'W' :
                    (!isUndNullEmp({ data: payment?.conciliationRemark, subMethod: currentMethod, })?.result && isUndNullEmp({ data: payment?.concilationStatus, subMethod: currentMethod, })?.result ? 'W' :
                        payment?.concilationStatus);

            payment.concilationStatus = concilationStatusLocal;
            //payment.conciliationOnly = true;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptPayment: payment,
                conciliationOnly: true,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPayments}/${payment?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentreceiptPaymentLocal = response?.result?.apartmentReceiptPayment || {};
            //#endregion update data (payment)

            //#region update payments (dtPaymenst)
            switch (processType) {
                case 1:
                    switch (apartmentreceiptPaymentLocal?.concilationStatus) {
                        case 'S':
                            buildingBalanceLocal = numberSet({
                                number: (numberSet({
                                    number: buildingBalance,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result - numberSet({
                                    number: apartmentreceiptPaymentLocal?.amount,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                }).result),
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result;
                            headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                                number: buildingBalanceLocal,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result;
                            setHeaderSectionValues(headerSectionValues);

                            dtPaymentsLocal?.row(rowIndex)?.remove()?.draw(true);
                            break;
                        default:
                            await dtPaymentUpdateDataAsync({
                                dtPayments: dtPaymentsLocal,
                                paymentConcilationStatus: isUndNullEmp({ data: apartmentreceiptPaymentLocal?.concilationStatus, subMethod: currentMethod, })?.result ?
                                    `<i class='fas fa-tag text-primary'></i>` : `<i class='fas fa-tag text-warning'></i>`,
                                subMethod: currentMethod,
                            });
                            break;
                    }
                    break;
                case 2:
                    switch (apartmentreceiptPaymentLocal?.concilationStatus) {
                        case 'S':
                            break;
                        default:
                            if (apartmentreceiptPaymentLocal?.concilationStatus !== paymentBeforeEdit?.concilationStatus) {
                                buildingBalanceLocal = numberSet({
                                    number: (numberSet({
                                        number: buildingBalance,
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result - numberSet({
                                        number: apartmentreceiptPaymentLocal?.amount,
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    }).result),
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                                headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                                    number: buildingBalanceLocal,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result;
                                setHeaderSectionValues(headerSectionValues);
                            }
                            dtPaymentsLocal?.row(rowIndex)?.remove()?.draw(true);
                            break;
                    }
                    break;
                default:
                    switch (apartmentreceiptPaymentLocal?.concilationStatus) {
                        case 'S':
                            //#region old code
                            // if (apartmentreceiptPaymentLocal?.concilationStatus !== paymentBeforeEdit?.concilationStatus) {
                            //     buildingBalanceLocal = numberSet({
                            //         number: (numberSet({
                            //             number: buildingBalance,
                            //             type: 'd',
                            //             languageId: languageObj?.id,
                            //             subMethod: currentMethod,
                            //         })?.result - numberSet({
                            //             number: apartmentreceiptPaymentLocal?.amount,
                            //             type: 'd',
                            //             languageId: languageObj?.id,
                            //             subMethod: currentMethod,
                            //         })?.result),
                            //         type: 'd',
                            //         languageId: languageObj?.id,
                            //         subMethod: currentMethod,
                            //     })?.result;
                            //     headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                            //         number: buildingBalanceLocal,
                            //         withDecimals: true,
                            //         consoleLogErrorShow: true,
                            //         subMethod: currentMethod,
                            //     })?.result;
                            //     setHeaderSectionValues(headerSectionValues);
                            // }
                            //#endregion old code

                            await dtPaymentUpdateDataAsync({
                                dtPayments: dtPaymentsLocal,
                                paymentConcilationStatus: `<i class='fas fa-tag text-success'></i>`,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            //#region old code
                            // if (apartmentreceiptPaymentLocal?.concilationStatus !== paymentBeforeEdit?.concilationStatus) {
                            //     if (paymentBeforeEdit?.concilationStatus === '' && apartmentreceiptPaymentLocal?.concilationStatus === 'W') {

                            //     } else if (paymentBeforeEdit?.concilationStatus === 'W' && apartmentreceiptPaymentLocal?.concilationStatus === '') {

                            //     } else if (paymentBeforeEdit?.concilationStatus === 'S' && (apartmentreceiptPaymentLocal?.concilationStatus === 'W' || apartmentreceiptPaymentLocal?.concilationStatus === '')) {
                            //         buildingBalanceLocal = numberSet({
                            //             number: (numberSet({
                            //                 number: buildingBalance,
                            //                 type: 'd',
                            //                 languageId: languageObj?.id,
                            //                 subMethod: currentMethod,
                            //             })?.result + numberSet({
                            //                 number: apartmentreceiptPaymentLocal?.amount,
                            //                 type: 'd',
                            //                 languageId: languageObj?.id,
                            //                 subMethod: currentMethod,
                            //             }).result),
                            //             type: 'd',
                            //             languageId: languageObj?.id,
                            //             subMethod: currentMethod,
                            //         })?.result;
                            //         headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                            //             number: buildingBalanceLocal,
                            //             withDecimals: true,
                            //             consoleLogErrorShow: true,
                            //             subMethod: currentMethod,
                            //         })?.result;
                            //         setHeaderSectionValues(headerSectionValues);
                            //     }
                            // }
                            //#endregion old code
                            await dtPaymentUpdateDataAsync({
                                dtPayments: dtPaymentsLocal,
                                paymentConcilationStatus: apartmentreceiptPaymentLocal?.concilationStatus === 'W' ?
                                    `<i class='fas fa-tag text-warning'></i>` : `<i class='fas fa-tag text-primary'></i>`,
                                subMethod: currentMethod,
                            });
                            //localDefaultValuesSet = true;
                            break;
                    }
                    break;
            }
            //#endregion update payments (dtPaymenst)

            //#region data set
            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });
            //#endregion data set

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.conciliationRemark?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.checkBox?.concilationStatus?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.collectionCashes?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'dataGetAsync';
        try {
            if (!isReadOnly) {
                setFormTitle(`${labels?.reconcile?.[languageObj?.id]} (${labels?.payment?.[languageObj?.id]?.toLowerCase()})`);
            } else {
                setFormTitle(`${labels?.reconcile?.[languageObj?.id]} (${labels?.payment?.[languageObj?.id]?.toLowerCase()} / ${labels?.details?.[languageObj?.id]?.toLowerCase()})`);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad'
        });
    }, [payment?.id]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.payment?.[languageObj?.id]}
                        src={images?.reconcilePaymentsLogo}
                        style={styles?.cardHeaderLogo}></img> - {formTitle}

                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => apartmentReceiptPaymentUpdateAsync({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => apartmentReceiptPaymentUpdateAsync(e)}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.payment?.[languageObj?.id]} src={images?.reconcilePaymentsLogo} style={styles?.cardHeaderLogo}></img> - {labels?.payment?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}

                    {/* <div className='card-body'> */}

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.apartment?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{apartment?.identifier || ''}</b>
                        </div>
                    </div>

                    <hr />

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.type?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{paymentMethodDescription}</b>
                        </div>
                    </div>

                    {!isUndNullEmp({ data: payment?.bankId, subMethod: '', })?.result ?
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {`${labels?.bank?.[languageObj?.id]}(${labels?.origin?.[languageObj?.id]})`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bankDescriptionOrigin}</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {`${labels?.bank?.[languageObj?.id]}(${labels?.destiny?.[languageObj?.id]})`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bankDescriptionDestiny}</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {`${labels?.number?.[languageObj?.id]}`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bankAccountNumber}</b>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.date?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{
                                dateTimeFormatGlobalSet({
                                    date: payment?.date,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result
                            }</b>
                        </div>
                    </div>

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.reference?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{payment?.reference || ''}</b>
                        </div>
                    </div>

                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.amount?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <b>{
                                separatorsNumbersSet({
                                    number: payment?.amount,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: 'lbl - amount',
                                })?.result
                            }</b>
                        </div>
                    </div>

                    <hr />

                    {/* <div className='form-group'> */}
                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {processTypeWindow === 1 ?
                                labels?.reconcile?.[languageObj?.id] :
                                labels?.reconcilied?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            <div className={controls?.checkBox?.concilationStatus?.className}>
                                <input checked={payment?.concilationStatus === 'S' || false}
                                    id={controls?.checkBox?.concilationStatus?.id}
                                    onChange={(e) => !isReadOnly ? paymentConcilationStatusCheck({ e: e, subMethod: 'chk - reconcileId', }) : null}
                                    readOnly={isReadOnly}
                                    type='checkbox' />
                                <label htmlFor={controls?.checkBox?.concilationStatus?.id}></label>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* <div className='form-group'> */}
                    {processTypeWindow === 0 &&
                        !isUndNullEmp({ data: userConciliation?.id, subMethod: currentMethod, })?.result ?
                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.user?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{`${userConciliation?.firstName || ''}, ${userConciliation?.lastName || ''}`}</b>
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {/* </div> */}

                    {/* <div className='form-group'> */}
                    {payment?.concilationStatus === 'S' ?
                        <div className='row text-muted'>
                            <div className='col-md-4'>
                                {labels?.date?.[languageObj?.id]}:
                            </div>
                            <div className='col-md-8'>
                                <b>{
                                    payment?.concilationStatus === 'S' ?
                                        dateTimeFormatGlobalSet({
                                            date: payment?.concilationDate,
                                            type: languageObj?.format?.date?.f1,
                                            format: languageObj?.format?.time?.type,
                                            languageId: languageObj?.id,
                                            subMethod: 'lbl - date',
                                        }).result :
                                        ''
                                }</b>
                            </div>
                        </div>
                        : 
                        <></>
                    }

                    {/* </div> */}

                    {isUndNullEmp({ data: payment?.bankId, subMethod: currentMethod, })?.result && payment?.concilationStatus === 'S' ?
                        <div className='form-group'>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.cashRegister?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    {processTypeWindow === 0 ?
                                        <b>{
                                            collectionCashes?.find(({ id }) => id === payment?.collectionCashId)?.description || ''
                                        }</b>
                                        :
                                        <select id={controls?.selects?.collectionCashes?.id}
                                            className={controls?.selects?.collectionCashes?.className}
                                            defaultValue={payment?.collectionCashId || ''}
                                            onChange={(e) => setPayment({
                                                ...payment,
                                                [dbProps?.collectionCashId]: e?.target?.value,
                                            })}
                                            onFocus={() => setCollectionCashError('')}
                                            tooltip='tooltip'
                                            title={labels?.cashRegister?.[languageObj?.id]}>
                                            <option key='nothing' value=''>{messages?.selectCashRegister?.[languageObj?.id]}</option>
                                            {
                                                collectionCashes?.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.description}</option>)
                                            }
                                        </select>
                                    }
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(collectionCashError)}</div>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }

                    {/* <div className='form-group'> */}
                    <div className='row text-muted'>
                        <div className='col-md-4'>
                            {labels?.remark?.[languageObj?.id]}:
                        </div>
                        <div className='col-md-8'>
                            {processTypeWindow === 1 ?
                                <textarea id={controls?.inputs?.conciliationRemark?.id}
                                    className={controls?.inputs?.conciliationRemark?.className}
                                    onChange={(e) => setPayment({
                                        ...payment,
                                        [dbProps?.conciliationRemark]: e?.target?.value,
                                    })}
                                    placeholder={`${labels?.enterRemark?.[languageObj?.id]}...`}
                                    readOnly={isReadOnly}
                                    rows={3}
                                    value={payment?.conciliationRemark || ''}>
                                </textarea>
                                :
                                <b>{HtmlParser(payment?.conciliationRemark?.replaceAll('\n', '<br/>'))}</b>
                            }

                        </div>
                    </div>
                    {/* </div> */}

                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {!isReadOnly ?
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button> :
                                    <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip' title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            disabled={isReadOnly}
                            hidden={isReadOnly}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}